/* [[ AUTO GENERATED - DO NOT MODIFY ]] */

export const OrderAddressType = {
    INVOICE: 'mail_to',
    DELIVERY: 'ship_to'
};
